import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellEditor, ICellEditorParams } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';
import { AgFrameworkComponent } from 'ag-grid-angular';

@Component({
    selector: '',
    standalone: true,
    imports: [],
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class BaseCellEditorComponent<TData, TValue, TContext, TCustomParams extends Object>
    implements AgFrameworkComponent<ICellEditorParams<TData, TValue, TContext>>, ICellEditor
{
    public baseParams = signal<ICellEditorParams<TData, TValue, TContext> | null>(null);
    public customParams = signal<TCustomParams | null>(null);
    agInit(params: ICellEditorParams<TData, TValue, TContext> & TCustomParams): void {
        this.baseParams.set(params);
        this.customParams.set(params);
    }
    abstract getValue(): TValue | null | undefined;
    cancel() {
        this.baseParams().api.stopEditing(true);
    }

    save() {}

    focusOut(): void {
        this.baseParams().api.stopEditing(true);
    }
}
